module.exports = __webpack_public_path__ + "static/img/digitaltwin1.e0e68b53.png";